export default "__VITE_ASSET__C5GZ9QN___"